<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar flat dark color="primary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Perfil {{ perfil.nome }}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <DataTableDeCrud
        :items="permissoes"
        :headers="headers"
        titulo="Vincular Permissão"
        :permissao-geral="true"
        :loading="loading"
        @create="() => abrirDialogVincularPermissao()"
        @delete="(indice) => abrirDialogExcluirPermissao(indice)"
      />
    </v-card>

    <DialogDeVinculacaoDaPermissaoComPerfil
      :show-dialog-vinculo.sync="showDialogParam"
      :perfil="perfil"
      :itens-permissao="itensPermissao"
      @confirmado="atualizarPermissao"
    />

    <SnackbarMessage
      :show-snack.sync="snackbar.showSnackParam"
      :snack-text="snackbar.snackTextParam"
      :snack-type="snackbar.snackTypeParam"
    />

    <v-dialog v-model="dialogExcluirPermissao" persistent max-width="380">
      <v-card>
        <v-card-title class="headline">Excluir</v-card-title>
        <v-card-text refs="itemPermissaoExclusao">
          Tem certeza que deseja remover o relacionamento do perfil com a permissão
          <b> {{ itemPermissaoExclusao.nome }} </b>?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="dialogExcluirPermissao = false">Cancelar</v-btn>
          <v-btn color="green darken-1" text @click="excluirPerfil">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import PerfilService from '@/services/usuario/perfil'
import PermissaoService from '@/services/usuario/permissao'
import DataTableDeCrud from '@/components/DataTableDeCrud'
import SnackbarMessage from '@/components/SnackbarMessage'
import DialogDeVinculacaoDaPermissaoComPerfil from './DialogDeVinculacaoDaPermissaoComPerfil'
import SnackBar from '@/models/components/snackbar'
import Perfil from '@/models/perfil'

export default {
  components: {
    SnackbarMessage,
    DataTableDeCrud,
    DialogDeVinculacaoDaPermissaoComPerfil
  },
  props: ['showDialogSettings', 'perfil'],
  data: () => ({
    headers: [{ text: 'Nome', value: 'nome' }],
    permissoes: [],
    itensPermissao: [],
    loading: false,
    validForm: false,
    dialog: false,
    dialogVincularPermissao: false,
    showDialogParam: false,
    snackbar: new SnackBar(),
    dialogExcluirPermissao: false,
    itemPermissaoExclusao: new Perfil(),
    indicePermissaoExclusao: 0
  }),

  watch: {
    showDialogSettings() {
      return this.showDialogSettings ? (this.dialog = this.showDialogSettings) : ''
    },
    perfil() {
      return this.perfil ? this.initialize(this.perfil) : ''
    },
    dialog() {
      return this.dialog ? true : this.fecharDialog()
    }
  },

  methods: {
    initialize() {
      this.buscarPermissoesDoPerfil(this.perfil.id)
      this.buscarTodasPermissoes()
    },

    async buscarTodasPermissoes() {
      try {
        const response = await PermissaoService.getAll()
        this.itensPermissao = response.map((item) => ({
          text: item.nome,
          value: item.id
        }))
      } catch (error) {
        this.snackbar.snackTextParam = 'Não foi possível encontrar as permissões cadastradas.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
    },

    async buscarPermissoesDoPerfil(perfilId) {
      try {
        this.permissoes = await PerfilService.getPermissoesByPerfil(perfilId)
      } catch (error) {
        this.snackbar.snackTextParam =
          'Não foi possível encontrar as permissões relacionadas à este perfil.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
    },

    atualizarPermissao(permissao) {
      if (!permissao) return

      this.permissoes.push(permissao)
      this.snackbar.snackTextParam = 'Permissão vinculada com sucesso.'
      this.snackbar.snackTypeParam = 'sucess'
      this.snackbar.showSnackParam = true
    },

    abrirDialogExcluirPermissao(indice) {
      this.itemPermissaoExclusao = this.permissoes[indice]
      if (!this.itemPermissaoExclusao.id) return

      this.indicePermissaoExclusao = indice
      this.dialogExcluirPermissao = true
    },

    async excluirPerfil() {
      try {
        await PerfilService.removePermissaoRelationship(this.itemPermissaoExclusao.id)
        this.snackbar.snackTextParam =
          'Relacionamento da permissão com o perfil removida com sucesso.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true
        this.permissoes.splice(this.indicePerfilExclusao, 1)
      } catch (error) {
        this.snackbar.snackTextParam = `${error.response.status} | ${
          error.response.data.message === undefined ? error.message : error.response.data.message
        }`
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
      this.dialogExcluirPermissao = false
    },

    fecharDialog() {
      this.$emit('update:showDialogSettings', false)
    },

    abrirDialogVincularPermissao() {
      this.showDialogParam = true
    }
  }
}
</script>
